type Subscriber = (timeLeft: number) => void;

class TimerSingleton {
  private static instance: TimerSingleton;
  private initialTimeInSeconds = 15 * 60; // 15 minutes in seconds
  private timeLeft: number;
  private subscribers: Subscriber[] = [];
  private interval: NodeJS.Timeout | null = null;

  private constructor() {
    this.timeLeft = this.initialTimeInSeconds;
  }

  public static getInstance(): TimerSingleton {
    if (!TimerSingleton.instance) {
      TimerSingleton.instance = new TimerSingleton();
    }
    return TimerSingleton.instance;
  }

  public startTimer(): void {
    if (!this.interval) {
      this.interval = setInterval(() => {
        if (this.timeLeft <= 1) {
          this.timeLeft = this.initialTimeInSeconds; // Restart timer
        } else {
          this.timeLeft -= 1; // Decrement timer
        }
        this.notifySubscribers();
      }, 1000);
    }
  }

  public subscribe(callback: Subscriber): void {
    this.subscribers.push(callback);
    callback(this.timeLeft); // Immediately send the current time
  }

  public unsubscribe(callback: Subscriber): void {
    this.subscribers = this.subscribers.filter((subscriber) => subscriber !== callback);
  }

  private notifySubscribers(): void {
    this.subscribers.forEach((callback) => callback(this.timeLeft));
  }
}

export default TimerSingleton.getInstance();
